<template>
  <card-item :disableId="true" card="item_variant" :tabs="tabs" v-model="activeTab"
    :id="`${id}${$store.state.user.sections['variants'] ? '' : '000030003'}`">

  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key: 'info',
          component: () => import("./Info"),
        },
        // {
        //   title: "Поля для заполнений",
        //   key:'fields',
        //   component: () => import("./Cards"),
        // },
      ],
      activeTab: 0,
    };
  },
};
</script>